import axios from "axios"
export const subscribe = async data => {
  return axios.post(
    `${process.env.GATSBY_NEXT_API_URL}/customer-io-subscription`,
    {
      ...data,
    }
  )
}
